import React from 'react';
import { Controller, FieldPathByValue, UseFormReturn } from 'react-hook-form';
import styles from './style.module.scss';
import CoreCheckbox from '@components-clean/core/core-checkbox';
import { SubjectProfileDetailsConfigurationFormValues } from './types';

type Props = {
    control: UseFormReturn<SubjectProfileDetailsConfigurationFormValues>['control'];
    disabled: boolean;
    checkboxKeys: {
        key: FieldPathByValue<SubjectProfileDetailsConfigurationFormValues, boolean | null>;
        label: React.ReactNode;
    }[];
};

export const SubjectProfileDetailsCheckboxList = ({ control, disabled, checkboxKeys }: Props) => {
    return (
        <div className={styles.checkboxListContainer}>
            <div className={styles.checkboxList}>
                {checkboxKeys.map((c) => (
                    <div key={c.key}>
                        <Controller
                            control={control}
                            name={c.key}
                            render={({ field: { onChange, value } }) => (
                                <CoreCheckbox
                                    value={value}
                                    onChange={onChange}
                                    disabled={disabled}
                                    label={c.label}
                                    data-testid={`checkbox-${c.key}`}
                                />
                            )}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SubjectProfileDetailsCheckboxList;
